/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { UIEmailNotificationGroup } from './Notifications.types';

export const UI_FIRST_PARTY_CLUSTER_CREATED = 'ui_first_party_cluster_created';
export const UI_FIRST_PARTY_CLUSTER_UPDATED = 'ui_first_party_cluster_updated';
export const UI_FIRST_PARTY_CLUSTER_DELETED = 'ui_first_party_cluster_deleted';
export const UI_FIRST_PARTY_CLUSTER_UNAVAILABLE = 'ui_first_party_cluster_unavailable';
export const UI_SECOND_PARTY_CLUSTER_CREATED = 'ui_second_party_cluster_created';
export const UI_SECOND_PARTY_CLUSTER_UPDATED = 'ui_second_party_cluster_updated';
export const UI_SECOND_PARTY_CLUSTER_DELETED = 'ui_second_party_cluster_deleted';
export const UI_SECOND_PARTY_CLUSTER_UNAVAILABLE = 'ui_second_party_cluster_unavailable';
export const EMAIL_FIRST_PARTY_CLUSTER_CREATED = 'email_first_party_cluster_created';
export const EMAIL_FIRST_PARTY_CLUSTER_UPDATED = 'email_first_party_cluster_updated';
export const EMAIL_FIRST_PARTY_CLUSTER_DELETED = 'email_first_party_cluster_deleted';
export const EMAIL_FIRST_PARTY_CLUSTER_UNAVAILABLE = 'email_first_party_cluster_unavailable';
export const EMAIL_SECOND_PARTY_CLUSTER_CREATED = 'email_second_party_cluster_created';
export const EMAIL_SECOND_PARTY_CLUSTER_UPDATED = 'email_second_party_cluster_updated';
export const EMAIL_SECOND_PARTY_CLUSTER_DELETED = 'email_second_party_cluster_deleted';
export const EMAIL_SECOND_PARTY_CLUSTER_UNAVAILABLE = 'email_second_party_cluster_unavailable';

export const firstPartyClusterNotifications: UIEmailNotificationGroup = {
  uiNotifications: [
    UI_FIRST_PARTY_CLUSTER_CREATED,
    UI_FIRST_PARTY_CLUSTER_UPDATED,
    UI_FIRST_PARTY_CLUSTER_DELETED,
    UI_FIRST_PARTY_CLUSTER_UNAVAILABLE,
  ],
  emailNotifications: [
    EMAIL_FIRST_PARTY_CLUSTER_CREATED,
    EMAIL_FIRST_PARTY_CLUSTER_UPDATED,
    EMAIL_FIRST_PARTY_CLUSTER_DELETED,
    EMAIL_FIRST_PARTY_CLUSTER_UNAVAILABLE,
  ],
  allNotifications: [
    UI_FIRST_PARTY_CLUSTER_CREATED,
    UI_FIRST_PARTY_CLUSTER_UPDATED,
    UI_FIRST_PARTY_CLUSTER_DELETED,
    UI_FIRST_PARTY_CLUSTER_UNAVAILABLE,
    EMAIL_FIRST_PARTY_CLUSTER_CREATED,
    EMAIL_FIRST_PARTY_CLUSTER_UPDATED,
    EMAIL_FIRST_PARTY_CLUSTER_DELETED,
    EMAIL_FIRST_PARTY_CLUSTER_UNAVAILABLE,
  ],
  rowsByType: {
    cluster_created: [UI_FIRST_PARTY_CLUSTER_CREATED, EMAIL_FIRST_PARTY_CLUSTER_CREATED],
    cluster_updated: [UI_FIRST_PARTY_CLUSTER_UPDATED, EMAIL_FIRST_PARTY_CLUSTER_UPDATED],
    cluster_deleted: [UI_FIRST_PARTY_CLUSTER_DELETED, EMAIL_FIRST_PARTY_CLUSTER_DELETED],
    cluster_unavailable: [UI_FIRST_PARTY_CLUSTER_UNAVAILABLE, EMAIL_FIRST_PARTY_CLUSTER_UNAVAILABLE],
  },
};

export const secondPartyClusterNotifications: UIEmailNotificationGroup = {
  uiNotifications: [
    UI_SECOND_PARTY_CLUSTER_CREATED,
    UI_SECOND_PARTY_CLUSTER_UPDATED,
    UI_SECOND_PARTY_CLUSTER_DELETED,
    UI_SECOND_PARTY_CLUSTER_UNAVAILABLE,
  ],
  emailNotifications: [
    EMAIL_SECOND_PARTY_CLUSTER_CREATED,
    EMAIL_SECOND_PARTY_CLUSTER_UPDATED,
    EMAIL_SECOND_PARTY_CLUSTER_DELETED,
    EMAIL_SECOND_PARTY_CLUSTER_UNAVAILABLE,
  ],
  allNotifications: [
    UI_SECOND_PARTY_CLUSTER_CREATED,
    UI_SECOND_PARTY_CLUSTER_UPDATED,
    UI_SECOND_PARTY_CLUSTER_DELETED,
    UI_SECOND_PARTY_CLUSTER_UNAVAILABLE,
    EMAIL_SECOND_PARTY_CLUSTER_CREATED,
    EMAIL_SECOND_PARTY_CLUSTER_UPDATED,
    EMAIL_SECOND_PARTY_CLUSTER_DELETED,
    EMAIL_SECOND_PARTY_CLUSTER_UNAVAILABLE,
  ],
  rowsByType: {
    cluster_created: [UI_SECOND_PARTY_CLUSTER_CREATED, EMAIL_SECOND_PARTY_CLUSTER_CREATED],
    cluster_updated: [UI_SECOND_PARTY_CLUSTER_UPDATED, EMAIL_SECOND_PARTY_CLUSTER_UPDATED],
    cluster_deleted: [UI_SECOND_PARTY_CLUSTER_DELETED, EMAIL_SECOND_PARTY_CLUSTER_DELETED],
    cluster_unavailable: [UI_SECOND_PARTY_CLUSTER_UNAVAILABLE, EMAIL_SECOND_PARTY_CLUSTER_UNAVAILABLE],
  },
};
